import { defineNuxtPlugin, useRouter, useRuntimeConfig } from 'nuxt/app';
import { createPosthogPlugin } from './createPosthogPlugin';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const result = createPosthogPlugin({
    posthogKey: runtimeConfig.public.posthogPublicKey as string,
    directHost: runtimeConfig.public.posthogHost as string,
    proxyHost: runtimeConfig.public.posthogProxyHost as string,
    router: useRouter(),
  });
  return { provide: result };
});
